import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/atendimento`

    return {
        create(filaId) {
            return repository.get(`${baseUrl}/create/${filaId}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getHistoricoPreAtendimento(id) {
            return repository.get(`${baseUrl}/historico-pre-atendimento/${id}`)
        },
        getHistoricoAtendimentoSoap(id) {
            return repository.get(`${baseUrl}/historico-atendimento-soap/${id}`)
        },
        getUrlHistoricoConectaSUSV1(prontuario) {
            return repository.get(`${baseUrl}/url-historico-conectasusv1/${prontuario}`)
        },
        exameDentroPrazoValidade(queryParms) {
            return repository.get(`${baseUrl}/exame-dentro-prazo-validade?${urlUtil.serialize(queryParms)}`)
        },
    }
}